import BorderColorIcon from "@mui/icons-material/BorderColor";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import { Box, Button, Link, Modal, TextField, Tooltip } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { GridCloseIcon } from "@mui/x-data-grid/components/icons";
import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SlidingPanel from "react-sliding-side-panel";
import Attachment from "../../../../../Components/Broker/Attachment/Attachment";
import EmailComponent from "../../../../../Components/Broker/EmailComponent/EmailComponent";
import EmployeeDetailPolicies from "../../../../../Components/Broker/EmployeeDetailPolicies/EmployeeDetailPolicies";
import EmployeeDetailProfile from "../../../../../Components/Broker/EmployeeDetailProfile/EmployeeDetailProfile";
import LogsTable from "../../../../../Components/Broker/LogsTable/LogsTable";
import NotesSection from "../../../../../Components/Broker/NotesSection/NotesSection";
import TasksSection from "../../../../../Components/Broker/TasksSection/TasksSection";
import BulkUploadForm from "../../../../../Components/Common/BulkUploadFormSP/BulkUploadForm";
import PostQueryForm from "../../../../../Components/Common/PostQuerySP/PostQueryForm";
import DatePicker from "../../../../../Supporting files/DatePicker/DatePicker";
import DatePickerDisable from "../../../../../Supporting files/DatePickerDisable/DatePickerDisable";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import RKTextFieldDisable from "../../../../../Supporting files/RKTextFieldDisable/RKTextFieldDisable";
import SearchDropdownDisable from "../../../../../Supporting files/SearchDropdownDisable/SearchDropdownDisable";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
import SelectDropdownDisable from "../../../../../Supporting files/SelectDropdownDisable/SelectDropdownDisable";
import "../../../../../formLayout.scss";
import SearchDropdown from "../../../../../Supporting files/SearchDropdown/SearchDropdown";
function EmployeeDetails() {
  const navigate = useNavigate();
  const [notesData, setNotesData] = useState<
    Array<{ name: string; date: Date; description: string }>
  >([]);
  const [Dob, setDob] = React.useState<Date | null>(new Date());
  const [Doj, setDoj] = React.useState<Date | null>(new Date());
  const [viewTabsStatus, setViewTabsStatus] = React.useState("overview");
  const [openEmail, setOpenEmail] = React.useState(false);
  const [addPolicy, setAddPolicy] = React.useState(false);
  const [deletePolicy, setDeletePolicy] = React.useState(false);
  const [addNominee, setAddNominee] = React.useState(false);
  const [addEcard, setAddEcard] = React.useState(false);
  const [downloadEcard, setDownloadEcard] = React.useState(false);
  const [deleteEcard, setDeleteEcard] = React.useState(false);
  const [fullName, setFullName] = React.useState("Vikas Saini");
  const [relationEmployee, setRelationEmployee] = React.useState("Brother");
  const [nomineeDob, setNomineeDob] = React.useState<Date | null>(new Date());
  const [age, setAge] = React.useState("25");
  const [selectMember, setSelectMember] = React.useState("Vikas Saini");
  const [healthEcard, setAddHealthEcard] = React.useState("PB223674780");
  const [organizationName, setOrganizationName] = React.useState("Evervent");
  const [empId, setEmpId] = React.useState("EMP1234");
  const [orgNumber, setOrgNumber] = React.useState("98897894564");
  const [orgEmail, setOrgEmail] = React.useState("hello@evervent.in");
  const [personalemail, setPersonalEmail] = React.useState(
    "Kartike.kakkar@evervent.in"
  );
  const [emailcomp, setEmailComp] = React.useState(false);
  const [mobilenumber, setMobileNumber] = React.useState("8965455451");
  const [firstName, setFirstName] = React.useState("kartike");
  const [middleName, setMiddleName] = React.useState("kartike");
  const [lastName, setLastName] = React.useState("kakkar");
  const [Department, setDepartment] = React.useState("FrontEnd");
  const [Designation, setDesignation] = React.useState(
    "Ass. Frontend Developer"
  );
  const [salary, setSalary] = React.useState("₹ 1,00,000");
  const [salaryBracket, setSalaryBracket] = React.useState(
    "₹ 1,00,000 - ₹ 5,00,000"
  );
  const [gender, setGender] = React.useState("Male");
  const [buildingName, setBuildingName] = React.useState("Next57,341,phase 9");
  const [areaName, setAreaName] = React.useState("Industrial Area");
  const [country, setCountry] = React.useState("India");
  const [State, setState] = React.useState("Punjab");
  const [location, setLocation] = React.useState("Registerd Office");
  const [City, setCity] = React.useState("Mohali");
  const [Zipcode, setZipcode] = React.useState("160062");
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const [removeStatus, setRemoveStatus] = React.useState(false);
  const [uploadFile, setUploadFile] = React.useState(false);
  const [priorityStatus, setPriorityStatus] = React.useState("Pending");
  const [sectionStatus, SetSectionStatus] =
    React.useState<string>("personalDetails");
  const [subSection, setSubSection] = React.useState("basicinfo");
  const [postQueryForm, setPostQueryForm] = React.useState(false);
  const [attachment, setAttachment] = React.useState(false);
  const [relationEmployees, setRelationEmployees] = React.useState("Self");
  const relationEmployee_data = [
    { key: "Brother", value: "Brother" },
    { key: "Sister", value: "Sister" },
  ];
  const selectMember_data = [
    { key: "Vikas Saini", value: "Vikas Saini" },
    { key: "Kartike Kakkar", value: "Kartike Kakkar" },
    { key: "Rahul Raghuvanshi", value: "Rahul Raghuvanshi" },
  ];
  const gender_data = [
    { key: "Male", value: "Male" },
    { key: "Female", value: "Female" },
  ];
  const salaryBracket_data = [
    { key: "Below ₹ 1,00,000", value: "Below ₹ 1,00,000" },
    { key: "₹ 1,00,000 - ₹ 5,00,000", value: "₹ 1,00,000 - ₹ 5,00,000" },
    { key: "₹ 5,00,000 - ₹ 10,00,000", value: "₹ 5,00,000 - ₹ 10,00,000" },
    { key: "Above ₹ 10,00,000", value: "Above ₹ 10,00,000" },
  ];
  const relationEmployees_data = [
    { label: "Self", value: "Self" },
    { label: "Husband", value: "Husband" },
    { label: "Wife", value: "Wife" },
    { label: "Daughter", value: "Daughter" },
    { label: "Son", value: "Son" },
    { label: "Mother", value: "Mother" },
    { label: "Father", value: "Father" },
    { label: "Mother in Law", value: "Mother in Law" },
    { label: "Father in Law", value: "Father in Law" },
  ];

  const location_data = [
    { label: "Registered Office", value: "Registerd Office" },
    { label: "Regional Office", value: "RegionalOffice" },
    { label: "State Head Office", value: "StateHeadOffice" },
    { label: "City Office", value: "CityOffice" },
    { label: "City Sub Office", value: "CitySubOffice" },
  ];

  const prioritystatusData = [
    { key: "Pending", value: "Pending" },
    { key: "Expired", value: "Expired" },
    { key: "Active", value: "Active" },
    { key: "Rejected", value: "Rejected" },
    { key: "Inprogress", value: "Inprogress" },
  ];

  const Department_data = [
    { label: "Engineering", value: "Engineering" },
    { label: "IT", value: "IT" },
    { label: "Human Resource", value: "Human Resource" },
    { label: "Business Development", value: "Business Development" },
    { label: "Designing", value: "Designing" },
    { label: "Management", value: "Management" },
  ];
  const country_data = [
    { label: "India", value: "India" },
    { label: "Australia", value: "Australia" },
    { label: "England", value: "England" },
    { label: "New Zealand", value: "New Zealand" },
    { label: " South Africa", value: "South Africa" },
  ];
  const Designation_data = [
    {
      label: "Associate Frontend Developer",
      value: "Associate Frontend Developer",
    },
    { label: "Frontend Developer", value: "Frontend Developer" },
    { label: "Senior Frontend Developer", value: "Senior Frontend Developer" },
    {
      label: "Associate Software Engineer",
      value: "Associate Software Engineer",
    },
    { label: "Software Engineer", value: "Software Engineer" },
    { label: "Associate Hr", value: "Associate Hr" },
    { label: "Hr Executive", value: "Hr Executive" },
  ];
  const state_data = [
    { label: "Rajasthan", value: "Rajasthan" },
    { label: "Punjab", value: "Punjab" },
    { label: "Haryana", value: "Haryana" },
    { label: "Kerla", value: "Kerla" },
    { label: "Delhi", value: "Delhi" },
  ];
  const city_data = [
    { label: "Ambala", value: "Ambala" },
    { label: "Nanital", value: "Nanital" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Jaipur", value: "Jaipur" },
    { label: " New Delhi", value: "New Delhi" },
  ];

  // for scrolling
  const personalDetails = useRef(null);
  const emailSection = useRef(null);
  const attatchmentsdetails = useRef(null);
  const tododetails = useRef(null);
  const notes = useRef(null);
  const basicinfo = useRef(null);
  const professional = useRef(null);
  const addressdetails = useRef(null);
  //const personaladdress = useRef(null);

  const scrollToSection = (elementRef: any) => {
    // debugger;
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleClicks = (ref: any) => {
    console.log("handle click", ref);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const updateMasterState = (attrName: any, value: string) => {
    attrName(value);
  };

  //for policy Tab Table Data
  //Table Data
  const [columns, setColumns] = React.useState([
    {
      field: "policy_id",
      headerName: "Policy ID",
      width: 170,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link
            underline="none"
            style={{
              cursor: "pointer",
              fontWeight: "400",
              color: "#2166AA",
              textDecoration: "none",
            }}
            onClick={() => {
              navigate("/PolicyDetail");
            }}
          >
            EPZ08665R56456
          </Link>
        );
      },
    },

    {
      field: "policy_type",
      headerName: "Policy Type",
      width: 250,
      check_status: true,
    },
    {
      field: "insurer",
      headerName: "Insurer",
      width: 250,
      check_status: true,
    },
    {
      field: "policynumber",
      headerName: "Policy Number",
      width: 180,
      check_status: true,
    },
    {
      field: "start_date",
      headerName: "Start Date",
      width: 130,
      check_status: true,
    },
    {
      field: "end_date",
      headerName: "End Date",
      width: 130,
      check_status: true,
    },
    {
      field: "cdbal",
      headerName: "No. of Dependants",
      width: 180,
      check_status: true,
    },
    {
      field: "nol",
      headerName: "No.of Lives",
      width: 100,
      check_status: true,
    },
    {
      field: "plan_type",
      headerName: "Plan Type",
      width: 150,
      check_status: true,
    },
    {
      field: "coverage_type",
      headerName: "Coverage Type",
      width: 200,
      check_status: true,
    },

    {
      field: "basic_config",
      headerName: "Basic Configuration",
      width: 200,
      check_status: true,
    },
    {
      field: "individual_config",
      headerName: "Individual Configuration",
      width: 200,
      check_status: true,
    },
    {
      field: "feature_list",
      headerName: "Feature list / limitations",
      width: 200,
      check_status: true,
    },
    {
      field: "location_name",
      headerName: "Location Name",
      width: 200,
      check_status: true,
    },
    {
      field: "sum_assured",
      headerName: "Sum Assured/Insured",
      width: 200,
      check_status: true,
    },
    {
      field: "premium",
      headerName: "Premium",
      width: 200,
      check_status: true,
    },
    {
      field: "ecard",
      headerName: "Action",
      width: 100,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <>
            <Link
              underline="none"
              onClick={() => {
                setDeletePolicy(true);
              }}
            >
              <img src="./images/delete_icon.svg" alt="" height={"17px"} />
            </Link>
          </>
        );
      },
    },
  ]);
  const rows = [
    {
      id: 0,
      policy_id: "EV234234234",
      status: "Rejected",
      policy_type: "Group Health Insurance",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      cdbal: "4",
      nol: "5",
      plan_type: "Graded",
      coverage_type: "Employee, Spouse, Children, Parents, Parent In Laws",
      basic_config: "1E+1S+1C+1C",
      individual_config: "1P + 1P",
      feature_list: "5",
      location_name: "Mo Unit",
      sum_assured: "2L",
      premium: "₹35,234",
      ecard: "",
    },
    {
      id: 1,
      policy_id: "EV234234234",
      status: "Active",
      policy_type: "Group Health Insurance",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      cdbal: "2",
      nol: "3",
      plan_type: "Flat",
      coverage_type: "Employee, Spouse, Children, Parents, Parent In Laws",
      basic_config: "1E+1S+1C+1C",
      individual_config: "1PIL + 1PIL",
      feature_list: "5",
      location_name: "Mo Unit",
      sum_assured: "3L",
      premium: "₹35,234",
      ecard: "add",
    },
    {
      id: 2,
      policy_id: "EV234234234",
      status: "Inprogress",
      policy_type: "Group Health Insurance",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      cdbal: "3",
      nol: "4",
      plan_type: "Graded",
      coverage_type: "Employee, Spouse, Children, Parents, Parent In Laws",
      basic_config: "1E+1S+1C+1C",
      individual_config: "1P + 1P",
      feature_list: "5",
      location_name: "Mo Unit",
      sum_assured: "5L",
      premium: "₹35,234",
      ecard: "add",
    },
    {
      id: 3,
      policy_id: "EV234234234",
      status: "Rejected",
      policy_type: "Group Health Insurance",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      cdbal: "3",
      nol: "4",
      plan_type: "Flat",
      coverage_type: "Employee, Spouse, Children, Parents, Parent In Laws",
      basic_config: "1E+1S+1C+1C",
      individual_config: "1PIL + 1PIL",
      feature_list: "5",
      location_name: "Mo Unit",
      sum_assured: "2L",
      premium: "₹35,234",
      ecard: "add",
    },
    {
      id: 4,
      policy_id: "EV234234234",
      status: "Pending",
      policy_type: "Group Health Insurance",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      cdbal: "2",
      nol: "3",
      plan_type: "Graded",
      coverage_type: "Employee, Spouse, Children, Parents, Parent In Laws",
      basic_config: "1E+1S+1C+1C",
      individual_config: "1P + 1P",
      feature_list: "5",
      location_name: "Mo Unit",
      sum_assured: "3L",
      premium: "₹35,234",
      ecard: "add",
    },
    {
      id: 5,
      policy_id: "EV234234234",
      status: "Inprogress",
      policy_type: "Group Health Insurance",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      cdbal: "3",
      nol: "4",
      plan_type: "Flat",
      coverage_type: "Employee, Spouse, Children, Parents, Parent In Laws",
      basic_config: "1E+1S+1C+1C",
      individual_config: "1PIL + 1PIL",
      feature_list: "5",
      location_name: "Mo Unit",
      sum_assured: "5L",
      premium: "₹35,234",
      ecard: "add",
    },
  ];

  const employee_table_data = [
    {
      policy_no: "PVAZ23456788",
      product_type: "Group Health",
      basic_config: "1E+1S+1C+1C+1C+1C",
      individual_config: "Nill",
      checkbox_status: false,
      check_status: "",
      insurer: "HDFC Ergo",
    },
    {
      policy_no: "PVAZ23456788",
      product_type: "Group Term",
      basic_config: "1E+1S+1C+1C+1C",
      individual_config: "1P+1P",
      checkbox_status: false,
      check_status: "",
      insurer: "Star",
    },
    {
      policy_no: "PVAZ23456788",
      product_type: "Group Personal Accident",
      basic_config: "1E+1S+1C+1C",
      individual_config: "1PIL+1PIL",
      checkbox_status: false,
      check_status: "",
      insurer: "Bajaj Allianz",
    },
    {
      policy_no: "PVAZ23456788",
      product_type: "Group Critical Illness",
      basic_config: "1E+1S+1C",
      individual_config: "1P+1P+1PIL+1PIL",
      checkbox_status: false,
      check_status: "",
      insurer: "Royal Sundaram",
    },
  ];

  // nominee tabs

  const nominee_table_data = [
    {
      full_name: "Vikas Saini",
      relationship: "Brother",
      dob: "22 Feb, 1999",
      age: "24",
      checkbox_status: true,
      check_status: "",
    },
    {
      full_name: "Vikas Saini",
      relationship: "Brother",
      dob: "22 Feb, 1999",
      age: "24",
      checkbox_status: false,
      check_status: "",
    },
    {
      full_name: "Vikas Saini",
      relationship: "Brother",
      dob: "22 Feb, 1999",
      age: "24",
      checkbox_status: true,
      check_status: "",
    },
    {
      full_name: "Vikas Saini",
      relationship: "Brother",
      dob: "22 Feb, 1999",
      age: "24",
      checkbox_status: false,
      check_status: "",
    },
  ];
  // nominee health ecard table

  const health_table_data = [
    {
      policy_num: "PB22345780",
      ecard: "PB22345679",
      file_name: "621c94f41153e1835257b41b_lead mockup.webp",
      date: "30 Nov, 2022",
      time: "11:00 PM",
    },
  ];
  const [type, setType] = useState("");
  useEffect(() => {
    const windowURL = window.location.search;
    const params = new URLSearchParams(windowURL);

    const type = params.get("type");

    setType(type === null ? "" : type);
  }, []);

  return (
    <Box className="layoutWrapper">
      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate(-1);
            }}
          >
            <ChevronLeftIcon />
          </Link>
          <span className="detailIcon">A</span>
          <div>
            <h3>Ankit Sachdeva</h3>
            <p>CN0001 - Created on 12th Nov, 2022</p>
          </div>
        </Grid>
        <Grid
          xs={6}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        >
          <div>
            <Tooltip title="Remove">
              <Link
                underline="none"
                className="actionLinks red_icon"
                onClick={() => {
                  setRemoveStatus(true);
                }}
              >
                <DeleteOutlineIcon />
              </Link>
            </Tooltip>
          </div>
          <div></div>
          <div>
            <Tooltip title="Global Edit">
              <Link
                className="actionLinks"
                onClick={() => {
                  // navigate("/AddNewContact");
                }}
              >
                <BorderColorIcon />
              </Link>
            </Tooltip>
          </div>
          {/* Status Dropdown */}
          <div id={priorityStatus}>
            <div className="status_dropdown" id={priorityStatus}>
              {priorityStatus === "Highest" || priorityStatus === "Active" ? (
                <CheckCircleIcon id={priorityStatus} />
              ) : priorityStatus == "" || priorityStatus === "Rejected" ? (
                <CancelIcon id={priorityStatus} />
              ) : priorityStatus == "Pending" ? (
                <HourglassTopIcon id={priorityStatus} />
              ) : priorityStatus == "Inprogress" ? (
                <PublishedWithChangesIcon id={priorityStatus} />
              ) : priorityStatus == "Expired" ? (
                <HistoryToggleOffIcon id={priorityStatus} />
              ) : null}
              <SelectDropdown
                class_name="inputFieldd"
                title=""
                value={priorityStatus}
                attrName={setPriorityStatus}
                value_update={updateMasterState}
                dropdown_data={prioritystatusData}
                warn_status={false}
              />
            </div>
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="leftSection h-100">
              <Link
                className={
                  sectionStatus === "personalDetails"
                    ? "active sectionLink personalDetails"
                    : "sectionLink personalDetails"
                }
                onClick={() => {
                  scrollToSection(personalDetails);
                  SetSectionStatus("personalDetails");
                }}
              >
                <span> Personal Details</span>
              </Link>
              <ul className="accordion_list">
                <li>
                  <Link
                    className={
                      subSection === "basicinfo"
                        ? "inner_link active basicinfo"
                        : "inner_link basicinfo"
                    }
                    onClick={() => {
                      setSubSection("basicinfo");
                      handleClicks(subSection);
                      scrollToSection(basicinfo);
                    }}
                  >
                    Basic info
                  </Link>
                </li>
                <li>
                  <Link
                    className={
                      subSection === "professional"
                        ? "inner_link active professional"
                        : "inner_link professional"
                    }
                    onClick={() => {
                      setSubSection("professional");
                      handleClicks(subSection);
                      scrollToSection(professional);
                    }}
                  >
                    Professional Details
                  </Link>
                </li>
              </ul>
              <Link
                className={
                  sectionStatus === "addressdetails"
                    ? "active sectionLink addressdetails"
                    : "sectionLink addressdetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(addressdetails);
                  SetSectionStatus("addressdetails");
                }}
              >
                <span>Address Details</span>
              </Link>

              <Link
                className={
                  sectionStatus === "emailSection"
                    ? "active sectionLink emailSection"
                    : "sectionLink emailSection"
                }
                onClick={() => {
                  scrollToSection(emailSection);
                  SetSectionStatus("emailSection");
                }}
              >
                <span>Emails</span>
              </Link>

              <Link
                className={
                  sectionStatus === "attatchmentsdetails"
                    ? "active sectionLink attatchmentsdetails"
                    : "sectionLink attatchmentsdetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(attatchmentsdetails);
                  SetSectionStatus("attatchmentsdetails");
                }}
              >
                <span>Attatchments</span>
              </Link>

              <Link
                className={
                  sectionStatus === "tododetails"
                    ? "active sectionLink tododetails"
                    : "sectionLink tododetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(tododetails);
                  SetSectionStatus("tododetails");
                }}
              >
                <span> Tasks</span>
              </Link>
              <Link
                className={
                  sectionStatus === "notes"
                    ? "active sectionLink notes"
                    : "sectionLink notes"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(notes);
                  SetSectionStatus("notes");
                }}
              >
                <span>Notes</span>
              </Link>
            </Grid>
            <Grid
              xs
              className="rightSection h-100 overflow_hide"
              sx={{ overflow: "none" }}
            >
              <Grid container spacing={3} alignItems="center">
                <Grid lg={7} md={7} xs={12} className="pl-0">
                  <div className="productTabs ">
                    <Button
                      className={
                        viewTabsStatus == "overview"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "overview");
                      }}
                    >
                      Overview
                    </Button>
                    <Button
                      className={
                        viewTabsStatus == "policies"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "policies");
                      }}
                    >
                      Policies
                    </Button>
                    {type === "employee" ? (
                      <Button
                        className={
                          viewTabsStatus == "nominees"
                            ? "defaultTab active"
                            : "defaultTab"
                        }
                        onClick={() => {
                          updateMasterState(setViewTabsStatus, "nominees");
                        }}
                      >
                        Nominees
                      </Button>
                    ) : null}
                    {type === "employee" ? (
                      <Button
                        className={
                          viewTabsStatus == "profile"
                            ? "defaultTab active"
                            : "defaultTab"
                        }
                        onClick={() => {
                          updateMasterState(setViewTabsStatus, "profile");
                        }}
                      >
                        Profile
                      </Button>
                    ) : null}
                    <Button
                      className={
                        viewTabsStatus == "logs"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "logs");
                      }}
                    >
                      Logs
                    </Button>
                  </div>
                </Grid>
                <Grid
                  lg={5}
                  md={5}
                  xs={12}
                  style={{ textAlign: "right" }}
                  className="text-sm-center"
                >
                  <p className="lastupdate">
                    Last Update: 11:00AM, 10th Nov, 2022
                  </p>
                </Grid>
              </Grid>
              {viewTabsStatus == "overview" ? (
                <>
                  <Grid container className="mb-1">
                    <Grid xs={12}>
                      <div className="client_info_section">
                        <p className="client_info_p empID md_width">
                          Client ID : <span>CL00001</span>
                        </p>
                        <p className="client_info_p totalEmployees md_width">
                          Member ID: <span>FAR252ZI</span>
                        </p>
                        {type === "dependant" ? (
                          <p className="client_info_p user md_width">
                            Primary Employee Member ID: <span>EV 065</span>
                          </p>
                        ) : null}
                      </div>
                    </Grid>
                  </Grid>

                  <Box className="detailSection" ref={personalDetails}>
                    <div className="sectionTitle">
                      <h4>Personal Details</h4>
                    </div>
                    <div ref={basicinfo}>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Basic info</h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="First Name"
                            value={firstName}
                            attrName={setFirstName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Middle Name"
                            value={middleName}
                            attrName={setMiddleName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Last Name"
                            value={lastName}
                            attrName={setLastName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <SelectDropdownDisable
                            class_name="inputField"
                            title="Gender"
                            value={gender}
                            attrName={setGender}
                            value_update={updateMasterState}
                            dropdown_data={gender_data}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <DatePickerDisable
                            class_name="inputField"
                            title="Date of Birth"
                            value={Dob}
                            attrName={setDob}
                            value_update={updateMasterState}
                            error_message="Please enter Date of Birth"
                            warn_status={false}
                          />
                        </Grid>
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Contact Number"
                            value={mobilenumber}
                            attrName={setMobileNumber}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Email"
                            value={personalemail}
                            attrName={setPersonalEmail}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={4} lg={3} xl={3}>
                          <SearchDropdown
                            class_name="inputField"
                            title="Relationship with Employee"
                            value={relationEmployees}
                            attrName={setRelationEmployees}
                            value_update={updateMasterState}
                            data={relationEmployees_data}
                            warn_status={false}
                            error_message="Please select relation"
                          />
                        </Grid>
                        <Grid
                          xs={6}
                          md={4}
                          lg={3}
                          xl={3}
                          className="member_detail"
                        >
                          <div>
                            <h4>
                              Primary Employee
                              <span>Kartike Kakkar</span>
                            </h4>
                          </div>
                        </Grid>
                      </Grid>
                    </div>

                    {type === "employee" ? (
                      <div ref={professional}>
                        <Grid container spacing={3}>
                          <Grid xs={12}>
                            <h5 className="subHeading">Professional Details</h5>
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid xs={6} md={5} lg={3} xl={2}>
                            <RKTextFieldDisable
                              class_name="inputField"
                              title="Organization"
                              value={organizationName}
                              attrName={setOrganizationName}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={6} md={5} lg={3} xl={2}>
                            <SearchDropdownDisable
                              class_name="inputField"
                              title="Location"
                              value={location}
                              attrName={setLocation}
                              value_update={updateMasterState}
                              data={location_data}
                              warn_status={false}
                              error_message="Please select client"
                            />
                          </Grid>
                          <Grid xs={6} md={5} lg={3} xl={2}>
                            <RKTextFieldDisable
                              class_name="inputField"
                              title="Employee ID Field"
                              value={empId}
                              attrName={setEmpId}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid sm={6} md={5} lg={3} xl={3}>
                            <SearchDropdownDisable
                              class_name="inputField"
                              title="Department"
                              value={Department}
                              attrName={setDepartment}
                              value_update={updateMasterState}
                              data={Department_data}
                              warn_status={false}
                              error_message="Please select client"
                            />
                          </Grid>
                          <Grid sm={6} md={5} lg={3} xl={3}>
                            <SearchDropdownDisable
                              class_name="inputField"
                              title="Designation"
                              value={Designation}
                              attrName={setDesignation}
                              value_update={updateMasterState}
                              data={Designation_data}
                              warn_status={false}
                              error_message="Please select client"
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid sm={6} md={5} lg={3} xl={3}>
                            <RKTextFieldDisable
                              class_name="inputField"
                              title="Salary"
                              value={salary}
                              attrName={setSalary}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid sm={6} md={5} lg={3} xl={3}>
                            <SelectDropdownDisable
                              class_name="inputField"
                              title="Salary Bracket"
                              value={salaryBracket}
                              attrName={setSalaryBracket}
                              value_update={updateMasterState}
                              dropdown_data={salaryBracket_data}
                              warn_status={false}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid sm={4} md={4} lg={3} xl={2}>
                            <DatePickerDisable
                              class_name="inputField"
                              title="Date of Joining"
                              value={Doj}
                              attrName={setDoj}
                              value_update={updateMasterState}
                              error_message="Please enter Date of joining"
                              warn_status={false}
                            />
                          </Grid>
                          <Grid sm={4} md={4} lg={3} xl={2}>
                            <RKTextFieldDisable
                              class_name="inputField"
                              title={"Office Email"}
                              value={orgEmail}
                              attrName={setOrgEmail}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid sm={4} md={4} lg={3} xl={2}>
                            <RKTextFieldDisable
                              class_name="inputField"
                              title={"Office Contact Number"}
                              value={orgNumber}
                              attrName={setOrgNumber}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </Grid>
                        </Grid>
                      </div>
                    ) : null}
                  </Box>
                  <Box className="detailSection" ref={addressdetails}>
                    <div className="sectionTitle">
                      <h4>Personal Address Details</h4>
                    </div>

                    <div>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">
                            Personal Address Details
                          </h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={6} md={5} lg={4}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Building/Street Name"
                            value={buildingName}
                            attrName={setBuildingName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid sm={6} md={5} lg={4}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Area Name"
                            value={areaName}
                            attrName={setAreaName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <SearchDropdownDisable
                            class_name="inputField"
                            title="Country"
                            value={country}
                            attrName={setCountry}
                            value_update={updateMasterState}
                            data={country_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <SearchDropdownDisable
                            class_name="inputField"
                            title="State"
                            value={State}
                            attrName={setState}
                            value_update={updateMasterState}
                            data={state_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <SearchDropdownDisable
                            class_name="inputField"
                            title="City"
                            value={City}
                            attrName={setCity}
                            value_update={updateMasterState}
                            data={city_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title={"Zipcode"}
                            value={Zipcode}
                            attrName={setZipcode}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Box>
                  {/* we have hide this section for phase 2 */}
                  {/* <Box className="detailSection" ref={emailSection}>
                    <div className="sectionTitle">
                      <h4>Emails </h4>
                      <div className="actionBtns">
                        <Link
                          className="redBtn delete"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Delete
                        </Link>

                        <Link
                          className="blueBtn edit"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Compose
                        </Link>
                      </div>
                    </div>

                    <EmailComponent
                      open_status={emailcomp}
                      attrName={setEmailComp}
                      value_update={updateMasterState}
                    />
                  </Box> */}

                  <Box className="detailSection" ref={attatchmentsdetails}>
                    <div className="sectionTitle">
                      <h4>Attachments </h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => setUploadFile(true)}
                        >
                          Add Document
                        </Link>
                      </div>
                    </div>

                    {/* Attachment Section Start*/}
                    <Grid container spacing={3}>
                      <Grid xs={12} sx={{ padding: "0" }}>
                        <Attachment
                          open_status={attachment}
                          attrName={setAttachment}
                          value_update={updateMasterState}
                        />
                      </Grid>
                    </Grid>
                    {/* Attachment Section End*/}
                  </Box>

                  {/* we have hide this section for phase 2 */}

                  {/* <Box className="detailSection" ref={tododetails}>
                    <div className="sectionTitle">
                      <h4>Tasks</h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Add Task
                        </Link>
                      </div>
                    </div>
                    <Grid container spacing={3}>
                      <Grid xs={12}>
                        <TasksSection />
                      </Grid>
                    </Grid>
                  </Box> */}

                  <Box className="detailSection" ref={notes}>
                    <div className="sectionTitle">
                      <h4>Notes</h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => {
                            setPostQueryForm(true);
                          }}
                        >
                          Add Notes
                        </Link>
                      </div>
                    </div>

                    <NotesSection data={notesData} />
                  </Box>
                </>
              ) : null}
              {viewTabsStatus == "policies" ? (
                <>
                  <EmployeeDetailPolicies />
                </>
              ) : null}
              {viewTabsStatus == "nominees" ? (
                <>
                  <Box className="detailSection mt-4">
                    <div className="sectionTitle">
                      <h4>Nominee Details</h4>
                      <div className="actionBtns">
                        <Link
                          className="greenBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => setAddNominee(true)}
                        >
                          Add Nominee
                        </Link>
                      </div>
                    </div>
                    <div>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <div className="employee_table">
                            <div
                              className="employee_innerpart"
                              style={{ overflow: "hidden" }}
                            >
                              <ul className="heading">
                                <li>Full Name</li>
                                <li>Relationship</li>
                                <li>DOB</li>
                                <li>Age</li>
                                <li>PB23654587/GH</li>
                                <li>PB23655409/GPA</li>
                                <li>PB23655409/GTR</li>
                                <li>PB23651258/GT</li>
                                <li>PB23651258/GCI</li>
                                <li>Actions</li>
                              </ul>

                              {nominee_table_data.map((data, index) => (
                                <ul className="subheading">
                                  <li>{data.full_name}</li>
                                  <li>{data.relationship}</li>
                                  <li>{data.dob}</li>
                                  <li>{data.age}</li>
                                  <li>
                                    <div className="Checkbox">
                                      <input type="checkbox" name="check" />
                                      <label className="employee"></label>
                                    </div>
                                  </li>
                                  <li>
                                    <div className="Checkbox">
                                      <input type="checkbox" name="check" />
                                      <label className="gpa"></label>
                                    </div>
                                  </li>
                                  <li>
                                    <div className="Checkbox">
                                      <input type="checkbox" name="check" />
                                      <label className="gtr"></label>
                                    </div>
                                  </li>
                                  <li>
                                    <div className="Checkbox">
                                      <input type="checkbox" name="check" />
                                      <label className="gt"></label>
                                    </div>
                                  </li>
                                  <li>
                                    <div className="Checkbox">
                                      <input type="checkbox" name="check" />
                                      <label className="gci"></label>
                                    </div>
                                  </li>
                                  <li
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                    }}
                                  >
                                    <Link
                                      className="blueBtn edit ml-0"
                                      sx={{
                                        textDecoration: "none",
                                        cursor: "pointer",
                                      }}
                                    ></Link>
                                    <Link
                                      className="redBtn delete"
                                      onClick={() => {
                                        setDeleteStatus(true);
                                      }}
                                      sx={{
                                        textDecoration: "none",
                                        cursor: "pointer",
                                      }}
                                    ></Link>
                                  </li>
                                </ul>
                              ))}
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </Box>
                  {/* <Box className="detailSection mt-4">
                    <div className="sectionTitle">
                      <h4>Health/E-Card Details</h4>
                      <div className="actionBtns">
                        <Link
                          className="greenBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => setAddEcard(true)}
                        >
                          Add Health/E-Card
                        </Link>
                      </div>
                    </div>
                    <div>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <div className="employee_table">
                            <div
                              className="employee_innerpart"
                              style={{ overflow: "hidden" }}
                            >
                              <ul className="heading">
                                <li>Policy Number</li>
                                <li>Health/E-Card Number</li>
                                <li>File Name</li>
                                <li>Date</li>
                                <li>Time</li>
                                <li>Actions</li>
                              </ul>

                              {health_table_data.map((data, index) => (
                                <ul className="subheading">
                                  <li>{data.policy_num}</li>
                                  <li>{data.ecard}</li>
                                  <li>{data.file_name}</li>
                                  <li>{data.date}</li>
                                  <li>{data.time}</li>
                                  <li
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                    }}
                                  >
                                    <Link
                                      className="blueBtn download ml-0"
                                      sx={{
                                        textDecoration: "none",
                                        cursor: "pointer",
                                      }}
                                    ></Link>
                                    <Link
                                      className="redBtn delete"
                                      onClick={() => {
                                        setDeleteStatus(true);
                                      }}
                                      sx={{
                                        textDecoration: "none",
                                        cursor: "pointer",
                                      }}
                                    ></Link>
                                  </li>
                                </ul>
                              ))}
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </Box> */}
                </>
              ) : null}
              {viewTabsStatus == "profile" ? (
                <>
                  <EmployeeDetailProfile />
                </>
              ) : null}
              {viewTabsStatus == "logs" ? (
                <>
                  <Box>
                    <LogsTable />
                  </Box>
                </>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <SlidingPanel
        type={"right"}
        isOpen={openEmail}
        size={75}
        backdropClicked={() => setOpenEmail(false)}
      >
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={12}>
              <h4 className="mb-0 mt-4 ml-3">Emails</h4>
            </Grid>
            <Grid xs={12} className="mb-4">
              <hr />
            </Grid>
          </Grid>
          <div className="scrollable_area">
            <div className="email_section">
              <Grid container spacing={2}>
                <Grid xs={6}>
                  <h6 className="person_name">Rahul Raghuvanshi</h6>
                  <p className="subjects">Automation Enhancements</p>
                  <p className="cc_bcc">
                    Cc: <span>Karan Joshi, Umemsh Gemini</span>
                  </p>
                </Grid>
                <Grid xs={6} sx={{ textAlign: "right" }}>
                  <p className="date_time">30 Nov, 2022 at 11:00 AM</p>
                  <Link className="attatchment_section">
                    <img src="./images/attatch_icon.svg" className="" alt="" />
                    <img src="./images/drop_down.svg" className="ml-4" alt="" />
                  </Link>
                </Grid>
                <Grid xs={12}>
                  <hr />
                </Grid>
                <Grid xs={12}>
                  <p className="mail_common">Hello Umesh,</p>
                  <p className="mail_data">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    <br />
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </p>
                  <p className="thanks">Thanks & Regards,</p>
                  <p className="mail_common">Munjal Patel</p>
                  <p className="mail_common">APM, EVERVENT</p>
                  <p className="mail_common">Mobile: +917719403800</p>
                  <p className="mail_common">Email: munjal.patel@evervent.in</p>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </SlidingPanel>
      <PostQueryForm
        attrName={setPostQueryForm}
        open_status={postQueryForm}
        value_update={updateMasterState}
      />
      <BulkUploadForm
        open_status={uploadFile}
        attrName={setUploadFile}
        value_update={updateMasterState}
      />

      <Modal open={deleteStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setDeleteStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link className="md-link" underline="none">
                You are about to Delete this Health E-Card.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <Modal open={removeStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setRemoveStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link className="md-link" underline="none">
                You are want to remove this Contacts.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      {/* policies add policy popup */}

      <SlidingPanel
        type={"right"}
        isOpen={addPolicy}
        size={75}
        panelClassName="sliding-panel"
        backdropClicked={() => setAddPolicy(false)}
      >
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={10}>
              <h4 className="mb-0 mt-3 text-left">Add Policy</h4>
            </Grid>
            <Grid xs={2} textAlign="end" className="mt-2">
              <GridCloseIcon
                onClick={() => {
                  setAddPolicy(false);
                }}
              />
            </Grid>
            <Grid xs={12} className="mb-4">
              <hr />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            alignItems="center"
            sx={{ paddingTop: "0" }}
          >
            <Grid xs={12}>
              <div className="scrollable_area pr-5">
                <Grid container spacing={3} className="mb-1">
                  <Grid xs={12}>
                    <div className="client_info_section">
                      <p className="client_info_p empID md_width">
                        Client ID : <span>CL00001</span>
                      </p>
                    </div>
                  </Grid>
                  <Grid xs={12}>
                    <h5 className="subHeading mt-4">Select Policy</h5>
                  </Grid>
                  <Grid xs={12}>
                    <div className="employee_table">
                      <div
                        className="employee_innerpart"
                        style={{ overflow: "hidden" }}
                      >
                        <ul className="heading">
                          <li>Choose Policy</li>
                          <li>Active Policy Number</li>
                          <li>Product Type</li>
                          <li>Insurer</li>
                          <li>Basic configuration</li>
                          <li>Individual configuration</li>
                        </ul>

                        {employee_table_data.map((data, index) => (
                          <ul className="subheading">
                            <li>
                              <div className="Checkbox">
                                <input type="checkbox" name="check" />
                                <label className="employee"></label>
                              </div>
                            </li>
                            <li>{data.policy_no}</li>
                            <li>{data.product_type}</li>
                            <li>{data.insurer}</li>
                            <li>{data.basic_config}</li>
                            <li>{data.individual_config}</li>
                          </ul>
                        ))}
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid xs={12} className="footer_sec">
              <Link className="save_btn" onClick={() => setAddPolicy(false)}>
                Submit
              </Link>
            </Grid>
          </Grid>
        </div>
      </SlidingPanel>
      {/* policies add policy popup */}

      <SlidingPanel
        type={"right"}
        isOpen={deletePolicy}
        size={75}
        panelClassName="sliding-panel"
        backdropClicked={() => setDeletePolicy(false)}
      >
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={10}>
              <h4 className="mb-0 mt-3 text-left">Delete Policy</h4>
            </Grid>
            <Grid xs={2} textAlign="end" className="mt-2">
              <GridCloseIcon
                onClick={() => {
                  setDeletePolicy(false);
                }}
              />
            </Grid>
            <Grid xs={12} className="mb-4">
              <hr />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            alignItems="center"
            sx={{ paddingTop: "0" }}
          >
            <Grid xs={12}>
              <div className="scrollable_area pr-5">
                <Grid container spacing={3} className="mb-1">
                  <Grid xs={12}>
                    <div className="client_info_section">
                      <p className="client_info_p empID md_width">
                        Client ID : <span>CL00001</span>
                      </p>
                    </div>
                  </Grid>
                  <Grid xs={12}>
                    <h5 className="subHeading mt-4">Select Policy</h5>
                  </Grid>
                  <Grid xs={12}>
                    <div className="employee_table">
                      <div
                        className="employee_innerpart"
                        style={{ overflow: "hidden" }}
                      >
                        <ul className="heading">
                          <li>Choose Policy</li>
                          <li>Active Policy Number</li>
                          <li>Product Type</li>
                          <li>Insurer</li>
                          <li>Basic configuration</li>
                          <li>Individual configuration</li>
                        </ul>

                        {employee_table_data.map((data, index) => (
                          <ul className="subheading">
                            <li>
                              <div className="Checkbox">
                                <input type="checkbox" name="check" />
                                <label className="employee"></label>
                              </div>
                            </li>
                            <li>{data.policy_no}</li>
                            <li>{data.product_type}</li>
                            <li>{data.insurer}</li>
                            <li>{data.basic_config}</li>
                            <li>{data.individual_config}</li>
                          </ul>
                        ))}
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid xs={12} className="footer_sec">
              <Link className="save_btn" onClick={() => setDeletePolicy(false)}>
                Delete
              </Link>
            </Grid>
          </Grid>
        </div>
      </SlidingPanel>

      {/* Nominee add policy popup */}
      <SlidingPanel
        type={"right"}
        isOpen={addNominee}
        size={75}
        panelClassName="sliding-panel"
        backdropClicked={() => setAddNominee(false)}
      >
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={10}>
              <h4 className="mb-0 mt-3 text-left">Fill Nominee Details</h4>
            </Grid>
            <Grid xs={2} textAlign="end" className="mt-2">
              <GridCloseIcon
                onClick={() => {
                  setAddNominee(false);
                }}
              />
            </Grid>
            <Grid xs={12} className="mb-4">
              <hr />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            alignItems="center"
            sx={{ paddingTop: "0" }}
          >
            <Grid xs={12}>
              <div className="scrollable_area">
                <Grid container spacing={3}>
                  <Grid xs={6}>
                    <RKTextField
                      class_name="inputField"
                      title="Full Name"
                      value={fullName}
                      attrName={setFullName}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <SelectDropdown
                      class_name="inputField"
                      title="Relationship with employee"
                      value={relationEmployee}
                      attrName={setRelationEmployee}
                      value_update={updateMasterState}
                      dropdown_data={relationEmployee_data}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <DatePicker
                      class_name="inputField"
                      title="Date of Birth"
                      value={nomineeDob}
                      attrName={setNomineeDob}
                      value_update={updateMasterState}
                      error_message="Please enter Date of Birth"
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <RKTextField
                      class_name="inputField"
                      title="Age"
                      value={age}
                      attrName={setAge}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid xs={12} className="footer_sec">
              <Link className="save_btn" onClick={() => setAddNominee(false)}>
                Submit
              </Link>
            </Grid>
          </Grid>
        </div>
      </SlidingPanel>

      {/* health ecard policy popup */}
      <SlidingPanel
        type={"right"}
        isOpen={addEcard}
        size={75}
        panelClassName="sliding-panel"
        backdropClicked={() => setAddEcard(false)}
      >
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={10}>
              <h4 className="mb-0 mt-3 text-left">Add Health/E-Card Details</h4>
            </Grid>
            <Grid xs={2} textAlign="end" className="mt-2">
              <GridCloseIcon
                onClick={() => {
                  setAddEcard(false);
                }}
              />
            </Grid>

            <Grid xs={12} className="mb-4">
              <hr />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            alignItems="center"
            sx={{ paddingTop: "0" }}
          >
            <Grid xs={12}>
              <div className="scrollable_area ">
                <Grid container spacing={3}>
                  <Grid xs={12}>
                    <p className="health_ecard">
                      Policy Number
                      <span>PB223674780</span>
                    </p>
                  </Grid>
                  <Grid xs={6}>
                    <SelectDropdown
                      class_name="inputField"
                      title="Select Member"
                      value={selectMember}
                      attrName={setSelectMember}
                      value_update={updateMasterState}
                      dropdown_data={selectMember_data}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <RKTextField
                      class_name="inputField"
                      title="Enter Health/E-Card Number"
                      value={healthEcard}
                      attrName={setAddHealthEcard}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={0}>
                  <Grid xs={10} className="inputField uploadFile">
                    <TextField
                      fullWidth
                      id="outlined-basic"
                      label="Upload Document"
                      variant="outlined"
                      className="textarea"
                    />
                  </Grid>
                  <Grid xs={2}>
                    <Button variant="contained" className="browsebtn">
                      Browse
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid xs={12} className="footer_sec">
              <Link className="save_btn" onClick={() => setAddEcard(false)}>
                Submit
              </Link>
            </Grid>
          </Grid>
        </div>
      </SlidingPanel>

      {/* download health ecard policy popup */}
      <SlidingPanel
        type={"right"}
        isOpen={downloadEcard}
        size={75}
        panelClassName="sliding-panel"
        backdropClicked={() => setDownloadEcard(false)}
      >
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={10}>
              <h4 className="mb-0 mt-3 text-left">
                Download Health/E-Card Details
              </h4>
            </Grid>
            <Grid xs={2} textAlign="end" className="mt-2">
              <GridCloseIcon
                onClick={() => {
                  setDownloadEcard(false);
                }}
              />
            </Grid>
            <Grid xs={12} className="mb-4">
              <hr />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            alignItems="center"
            sx={{ paddingTop: "0" }}
          >
            <Grid xs={12}>
              <div className="scrollable_area ">
                <Grid container spacing={3}>
                  <Grid xs={12}>
                    <p className="health_ecard">
                      Policy Number
                      <span>PB223674780</span>
                    </p>
                  </Grid>
                  <Grid xs={6}>
                    <SelectDropdown
                      class_name="inputField"
                      title="Select Member"
                      value={selectMember}
                      attrName={setSelectMember}
                      value_update={updateMasterState}
                      dropdown_data={selectMember_data}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <p className="health_ecard">
                      Health E-card Number
                      <span>PB223674780</span>
                    </p>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid xs={12} className="footer_sec">
              <Link
                className="save_btn"
                onClick={() => setDownloadEcard(false)}
              >
                Download
              </Link>
            </Grid>
          </Grid>
        </div>
      </SlidingPanel>

      {/* delete health ecard policy popup */}
      <SlidingPanel
        type={"right"}
        isOpen={deleteEcard}
        size={75}
        panelClassName="sliding-panel"
        backdropClicked={() => setDeleteEcard(false)}
      >
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={10}>
              <h4 className="mb-0 mt-3 text-left">
                Delete Health/E-Card Details
              </h4>
            </Grid>
            <Grid xs={2} textAlign="end" className="mt-2">
              <GridCloseIcon
                onClick={() => {
                  setDeleteEcard(false);
                }}
              />
            </Grid>
            <Grid xs={12} className="mb-4">
              <hr />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            alignItems="center"
            sx={{ paddingTop: "0" }}
          >
            <Grid xs={12}>
              <div className="scrollable_area ">
                <Grid container spacing={3}>
                  <Grid xs={12}>
                    <p className="health_ecard">
                      Policy Number
                      <span>PB223674780</span>
                    </p>
                  </Grid>
                  <Grid xs={6}>
                    <SelectDropdown
                      class_name="inputField"
                      title="Select Member"
                      value={selectMember}
                      attrName={setSelectMember}
                      value_update={updateMasterState}
                      dropdown_data={selectMember_data}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <p className="health_ecard">
                      Health E-card Number
                      <span>PB223674780</span>
                    </p>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid xs={12} className="footer_sec">
              <Link className="save_btn" onClick={() => setDeleteEcard(false)}>
                Delete
              </Link>
            </Grid>
          </Grid>
        </div>
      </SlidingPanel>
    </Box>
  );
}
export default EmployeeDetails;
